"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SETUP_INTRO_COPY = exports.WELCOME_STEPS = void 0;
/**
 * The five steps of setup: the ONE copy (BEN-141 mobile parity).
 *
 * This text is the Welcome step's list, every slide of the setup tour, and the
 * welcome box's card descriptions, on web and mobile. It used to live twice --
 * `frontend/src/content/guidance/welcomeSteps.ts` and its mobile twin -- held
 * together by a parity test that could only notice drift after it happened. One
 * source cannot drift. It is also the tour's own copy, whose absence from
 * docs/copy/copy-inventory.md was the sharpest finding of the 2026-09-25 sweep, so
 * the inventory lists this file.
 */
exports.WELCOME_STEPS = [
    {
        id: "connect-accounts",
        title: "Connect your accounts",
        description: "Link your bank securely so Fomo-Fi can read the balances and transactions you choose.",
    },
    {
        id: "review-analysis",
        title: "Review your financial analysis",
        description: "Confirm the income, bills, and spending patterns Fomo-Fi identifies.",
    },
    {
        id: "build-forecast",
        title: "Build your forecast",
        description: "See what may happen before your next paycheck and in the months ahead.",
    },
    {
        id: "track-dashboard",
        title: "Track your dashboard",
        description: "See where you stand today and what your current plan sets aside.",
    },
    {
        id: "debt-plan",
        title: "Create your debt payoff plan",
        description: "Choose a payoff strategy and an extra-payment target that fits your cash flow.",
    },
];
/**
 * The sentence above the five items, wherever setup shows them. The five are the
 * journey, not setup's screens: setup is the first three (connect, review, build
 * the forecast) and the dashboard and debt plan come after it. The 2026-09-25
 * walkthrough found "Five steps" beside a rail reading "Step 1 of 8" and a
 * "0 of 2 completed" checklist, three counts for one flow. AN-35 (Anthony, 9 Oct):
 * the count itself was the problem: each app passed its own step list, so mobile
 * said 9 and web 8 for the same five items. SETUP_INTRO_COPY names no number.
 */
exports.SETUP_INTRO_COPY = "Setup covers the first three of these.";
//# sourceMappingURL=welcomeSteps.js.map